import { createContext, useContext } from 'react';

/**
 * 🔴 "THE SHELL HAS ALREADY DRAWN THE CHROME."
 *
 * `AppShell` renders exactly one `TopBar`, one project rail and one bottom tab bar, and then wraps
 * the `<Outlet/>` in this context set to `true`. Any `<TopBar/>` rendered by a VIEW inside that
 * outlet renders nothing.
 *
 * ⭐ Why this exists rather than "just delete the TopBar from each view": there are four views owned
 * by four different people, three of them being written right now, and the earlier backlog page
 * predates the shell and still renders its own. A rule that has to be remembered by four people gets
 * broken by one of them, and the symptom — two stacked 48px headers — only shows up on whichever
 * screen the reviewer happens to open. This makes the rule structural: a stray `<TopBar/>` inside
 * the shell is harmless, and one OUTSIDE the shell (the login screen) still works exactly as before.
 *
 * ⛔ It is not a licence to render chrome from a view. Views render CONTENT; the shell renders
 * chrome. This is the safety net under that contract, not a replacement for it.
 */
export const ShellChromeContext = createContext(false);

export function useShellRendersChrome(): boolean {
  return useContext(ShellChromeContext);
}
